var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFavorite = function SvgIconFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1B",
    fillOpacity: 0.88,
    d: "m8 14-.967-.867a75 75 0 0 1-2.783-2.616q-1.1-1.1-1.75-1.975-.65-.876-.908-1.609a4.5 4.5 0 0 1-.259-1.5q0-1.566 1.05-2.616T5 1.767q.867 0 1.65.366.783.368 1.35 1.034a3.95 3.95 0 0 1 1.35-1.034A3.85 3.85 0 0 1 11 1.767q1.567 0 2.617 1.05t1.05 2.616q0 .767-.259 1.5-.258.734-.908 1.609-.65.874-1.75 1.975a75 75 0 0 1-2.783 2.616zm0-1.8a73 73 0 0 0 2.633-2.458q1.034-1.026 1.634-1.784t.833-1.35q.233-.591.233-1.175 0-1-.666-1.666Q12 3.1 11 3.1q-.784 0-1.45.442t-.917 1.125H7.367q-.25-.683-.917-1.125A2.57 2.57 0 0 0 5 3.1q-1 0-1.667.667-.666.667-.666 1.666 0 .584.233 1.175.234.592.833 1.35.6.758 1.634 1.784A73 73 0 0 0 8 12.2"
  })));
};
export default SvgIconFavorite;